module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Thin.f419a75f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Thin.woff2
// module id = 3602
// module chunks = 68